import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export interface PageOption {
  id: number;
  fb_page_id?: string | null;
  page_name?: string | null;
  is_usable?: boolean | null;
  is_active?: boolean | null;
}

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  esteiraName?: string;
  pages: PageOption[];
  onSelect: (fbPageId: string) => void;
}

export default function PageSelectDialog({ open, onOpenChange, esteiraName, pages, onSelect }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Selecionar página</DialogTitle>
        </DialogHeader>
        <p className="-mt-2 text-xs text-muted-foreground">
          Páginas de {esteiraName ?? 'esteira'} · via token
        </p>
        <div className="max-h-[60vh] space-y-1 overflow-y-auto">
          {pages.length === 0 && (
            <div className="py-8 text-center text-sm text-muted-foreground">Nenhuma página nesta esteira.</div>
          )}
          {pages.map((p) => {
            const ok = p.is_usable !== false;
            return (
              <button
                key={p.id}
                onClick={() => { onSelect(p.fb_page_id ?? ''); onOpenChange(false); }}
                className="flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left transition hover:bg-muted"
              >
                <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-300 to-purple-400" />
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-semibold">{p.page_name ?? p.fb_page_id}</div>
                  <div className="truncate text-xs text-muted-foreground">{p.fb_page_id}</div>
                </div>
                <span className={`shrink-0 text-xs font-medium ${ok ? 'text-emerald-600' : 'text-amber-600'}`}>
                  {ok ? 'token ativo' : 'reconectar'}
                </span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
